import { FieldError } from 'common.types'

export const FieldErrorList: React.FC<{ errorListForField?: FieldError[] }> = ({
  errorListForField,
}) => {
  if (errorListForField) {
    return (
      <div className="error">
        {errorListForField.map((error, key) => (
          <p key={key}>{error.errorText}</p>
        ))}
      </div>
    )
  }
  return null
}
